exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".lc-pagination {\n  height: 40px;\n}\n.lc-pagination ul.pagination {\n  float: right;\n}\n.lc-pagination ul.pagination li {\n  margin-bottom: 0;\n}\n.lc-pagination ul.pagination li a.page-link.disabled {\n  pointer-events: none;\n}\n", ""]);

// exports
